import Container from "@mui/material/Container"
import React from "react"
import { Helmet } from "react-helmet"

import Sidebar from "@/components/layout/sidebar"
import { VenueDropdownMenu } from "@/components/layout/top_dropdown"
import CreateForm from "@/components/reservations/create_form"
import QuickCreateForm from "@/components/reservations/quick_create_form"
import { DropdownProvider } from "@/shared/dropdown"
import { useStore } from "@/store"

const Layout = ({
  title,
  className,
  fullWidth = false,
  padding = true,
  children,
  flex,
  "data-testid": testId,
}: {
  title: string
  className?: string
  fullWidth?: boolean
  padding?: boolean
  children: React.ReactNode
  flex?: boolean
  "data-testid"?: string
}) => {
  const { fullWidthMode } = useStore()
  const maxWidth = fullWidthMode || fullWidth ? false : undefined

  return (
    <DropdownProvider>
      <div className="min-h-screen pl-20 flex flex-col" data-testid="panel-layout">
        <Helmet>
          <title>
            {title}
            {title ? ` - ` : ""}Tabb
          </title>
        </Helmet>
        <Sidebar />
        <VenueDropdownMenu />
        <CreateForm />
        <QuickCreateForm />
        <Container
          maxWidth={maxWidth}
          data-testid={testId}
          className={`${padding ? "pt-4 pb-4" : ""} ${flex ? "flex-1 min-h-0 flex flex-col gap-4" : ""} ${className ?? ""}`}
        >
          {children}
        </Container>
      </div>
    </DropdownProvider>
  )
}

export default Layout
